import React from 'react'

import { CustomTheme, greyMultibrandPalette } from '@masfront/common-b2c'

import { Typography, Box, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme: CustomTheme) => ({
  footerList: {
    display: 'flex',
    padding: 0,
    margin: 0,
    '& li': {
      display: 'flex',
      flexDirection: 'row',
      padding: theme.spacing(0, 3),
      borderLeft: `2px ${greyMultibrandPalette[50]} solid`,
    },
    '& li:first-child': {
      paddingLeft: 0,
      borderLeft: 'none',
    },
  },
}))

interface CardFooterProps {
  footerItems: string[]
}

const SubscriptionCardFooter: React.FC<CardFooterProps> = ({ footerItems }) => {
  const styles = useStyles()
  return (
    <Box color={greyMultibrandPalette[500]}>
      <ul className={styles.footerList}>
        {footerItems.map((footerItem, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={i}>
            <Typography variant="h4" component={Box}>
              {footerItem}
            </Typography>
          </li>
        ))}
      </ul>
    </Box>
  )
}

export default SubscriptionCardFooter
